import React from 'react';
import moment from 'moment';
import { Modal, CheckBox, NumberInput } from 'hyperdb-utils';

const ReservationPricesDetails = (props) => {
  const handleChange = (attributeName, field) => {
    props.onChange({ ...props.editedPriceParams, [attributeName]: field.value });
  };
  const handleClickCheckbox = (attributeName, field) => {
    const checked = !props.editedPriceParams[attributeName];
    props.onChange({ ...props.editedPriceParams, [attributeName]: checked });
  };
  return (
    <div>
      <table className="table table-bordered table-striped details">
        <thead>
          <tr className="info">
            <th colSpan="2">
              Price details
              &nbsp;
              {
                props.extraInfo
                  ? <button onClick={ props.toggleModal.bind(null, true) } className="btn btn-primary btn-sm" title="Edit"><i className="fas fa-edit"/></button>
                  : null
              }
              &nbsp;
              {
                props.extraInfo
                  ? <button onClick={ props.toggleModalRecalculate.bind(null, true) } className="btn btn-warning btn-sm" title="Recalculate">Recalculate</button>
                  : null
              }
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Base price</td>
            <td>{ (props.reservation.base_price || 0).toFixed(2) } { props.reservation.currency }</td>
          </tr>
          <tr>
            <td>VAT ({props.reservation.vat}%)</td>
            <td>{ (props.reservation.vat_amount || 0).toFixed(2) } { props.reservation.currency }</td>
          </tr>
          <tr>
            <td>Cleaning cost</td>
            <td>{ (props.reservation.cleaning_fee || 0).toFixed(2) } { props.reservation.currency }</td>
          </tr>
          <tr>
            <td>Tourist tax</td>
            <td>{ (props.reservation.tourist_tax || 0).toFixed(2) } { props.reservation.currency }</td>
          </tr>
          <tr>
            <td>TOTAL</td>
            <td>{ (props.reservation.total_price || 0).toFixed(2) } { props.reservation.currency }</td>
          </tr>
          {
            props.extraInfo
              ? <tr>
                  <td>Base price per night</td>
                  <td>{ (props.reservation.base_price_per_night || 0).toFixed(2) } { props.reservation.currency }</td>
                </tr>
              : null
          }

        </tbody>
      </table>
      {
        props.showModalRecalculate
          ? <Modal show={true} title="Recalculate prices" onClose={props.toggleModalRecalculate.bind(null, false)} onAccept={props.onRecalculate} loading={ props.loading }>
              <div>Are you sure you want to recalculate the prices ?</div>
            </Modal>
          : null
      }
      {
        props.showModal
          ? <Modal show={true} onClose={props.toggleModal.bind(null, false)} onAccept={props.onSave} loading={ props.loading }>
              <NumberInput
                label="price (with vat)"
                name="price"
                value={ props.editedPriceParams.price }
                onChange={ handleChange.bind(null, 'price') }
              />
              <NumberInput
                label="deposit"
                name="deposit"
                value={ props.editedPriceParams.deposit }
                onChange={ handleChange.bind(null, 'deposit') }
              />
              <CheckBox
                label="disable VAT"
                name="disableVAT"
                checked={ props.editedPriceParams.disableVAT }
                onChange={ handleClickCheckbox.bind(null, 'disableVAT') }
              />
              <CheckBox
                label="disable cleaning fee"
                name="disable_cleaning_fee"
                checked={ props.editedPriceParams.disable_cleaning_fee }
                onChange={ handleClickCheckbox.bind(null, 'disable_cleaning_fee') }
              />
              <CheckBox
                label="disable tourist tax"
                name="disable_tourist_tax"
                checked={ props.editedPriceParams.disable_tourist_tax }
                onChange={ handleClickCheckbox.bind(null, 'disable_tourist_tax') }
              />
              {
                !props.editedPriceParams.disable_cleaning_fee
                  ? <NumberInput
                      label="Cleaning fee"
                      name="cleaning_fee"
                      value={ props.editedPriceParams.cleaning_fee }
                      onChange={ handleChange.bind(null, 'cleaning_fee') }
                    />
                  : null
              }
              {
                !props.editedPriceParams.disable_tourist_tax
                  ? <NumberInput
                      label="Tourist tax"
                      name="tourist_tax"
                      value={ props.editedPriceParams.tourist_tax }
                      onChange={ handleChange.bind(null, 'tourist_tax') }
                    />
                  : null
              }
            </Modal>
          : null
      }
    </div>
  );
};

export default ReservationPricesDetails;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/common/ReservationPricesDetails.jsx